import { format } from "date-fns";
import type { GoalFormModel } from "web_myplann/Goals/Forms/useGoalForm";
import { monthlyContribution } from "web_myplann/Goals/Helpers/monthlyContribution";
import {
	type CreateGoalRequestDTO,
	CurrencyEnum,
	GoalCategoryTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";

export const mapGoalFormToCreateRequest = (
	data: GoalFormModel,
): CreateGoalRequestDTO => {
	const ownFunds = data.ownFunds ?? 0;
	const loanAmount = data.loanAmount ?? 0;
	const savingsTarget = Math.max(0, data.totalValue - ownFunds - loanAmount);
	const periodicPayment = monthlyContribution(savingsTarget, data.dueDate);
	const isRentBased =
		data.category === GoalCategoryTypeEnum.Pension ||
		data.category === GoalCategoryTypeEnum.Rent;

	return {
		name: data.name,
		investmentPlanCategoryType: data.category,
		investmentHorizonEndDate: format(data.dueDate, DateFormat.Iso),
		currencyCode: CurrencyEnum.CZK,
		oneTimePayment: data.totalValue,
		periodicPayment: periodicPayment > 0 ? periodicPayment : null,
		loanAmount,
		ownFunds,
		monthlyRent: isRentBased ? (data.monthlyRent ?? null) : null,
		rentYears:
			isRentBased && data.drawdownMode === "to-zero"
				? (data.rentYears ?? null)
				: null,
	};
};
